import { render } from "./cpt-total.vue?vue&type=template&id=6f0524b0"
import script from "./cpt-total.vue?vue&type=script&lang=js"
export * from "./cpt-total.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__